import { fetchAuthSession } from "aws-amplify/auth";
import { callNotify } from "../..";
import { loginActions } from "../../pages/LoginPage/reducer";
import { getDispatch } from "../store/store";

export function err(response: any, data: any) {
    return { response, data };
}

async function checkStatus(response: Response) {
    const text = await response.text();
    let data: any = {};

    if (text) {
        try {
            data = JSON.parse(text);
        } catch {
            data = text;
        }
    }

    checkStatusCode(response.status);

    if (!response.ok) {
        throw err(response, data);
    }

    return data;
}

export function checkStatusCode(status: number) {
    if (status === 401) {
        const dispatch = getDispatch();
        dispatch(loginActions.logout())
    }
    if (status === 403) {
        callNotify?.error({ title: 'Access Denied' })
    }
}

const getToken = async (isAuthentication: boolean): Promise<{ Authorization: string } | {}> => {
    if (!isAuthentication)
        return {}

    const { tokens } = await fetchAuthSession();
    const token = tokens?.idToken?.toString();
    if (!token) {
        throw Error('Authentication invalid')
    }

    return { Authorization: ['Bearer', token].join(' ') }
}

interface IOpts<T> {
    isAuthentication?: boolean
    callback?: (value: T) => T,
    signal?: AbortSignal
    headers?: {
        [key: string]: any
    }
}

interface IOptsCallApi<T> extends IOpts<T> {
    method: "GET" | "POST" | "PUT" | "DELETE"
    body?: any
}

const callApi = async <T>(url: string, options: IOptsCallApi<T>): Promise<T> => {
    const { callback, headers: customHeaders, isAuthentication = true, ...args } = options;
    const headers = {
        'Content-Type': 'application/json',
        ...customHeaders,
        ...await getToken(isAuthentication)
    };

    const response = await fetch(url, { ...args, headers });
    const data = await checkStatus(response);
    let value = data;

    if (typeof data === 'string' && data.length > 0) {
        try {
            value = JSON.parse(data);
        } catch {
            value = data;
        }
    }

    return callback ? callback(value as T) : value as T;
};
export default callApi;

export const api = {
    get: <T>(url: string, opts: IOpts<T> = {}): Promise<T> => {
        return callApi<T>(url, { ...opts, method: 'GET' });
    },
    post: <T>(url: string, body: any = {}, opts: IOpts<T> = {}): Promise<T> => {
        return callApi<T>(url, { ...opts, body: JSON.stringify(body), method: 'POST' });
    },
    put: <T>(url: string, body: any = {}, opts: IOpts<T> = {}): Promise<T> => {
        return callApi<T>(url, { ...opts, body: JSON.stringify(body), method: 'PUT' });
    },
    delete: <T>(url: string, opts: IOpts<T> = {}): Promise<T> => {
        return callApi<T>(url, { ...opts, method: "DELETE" });
    },
    deleteBody: <T>(url: string, body: any, opts: IOpts<T> = {}): Promise<T> => {
        return callApi<T>(url, { ...opts, body: JSON.stringify(body), method: 'DELETE' });
    }
}
